"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
const util_1 = require("../util");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const dayjs_1 = __importDefault(require("dayjs"));
class InsightsQueryClient {
    constructor(config) {
        const responseParser = this.parseResponse.bind(this);
        this.apiManager = new util_1.APIUtils.APIManager(config.insightsUrl, index_1.Insights.InsightsEndpoints, responseParser);
    }
    parseResponse(response) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { status, statusText, headers, url } = response;
            const result = { status, statusText, headers, url };
            try {
                const responseJson = yield response.json();
                result.data = responseJson;
            }
            catch (e) {
                console.error(e);
            }
            if (response.status >= 400 && response.status < 600) {
                throw new util_1.APIUtils.RequestError(result, ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message) || "unknown error");
            }
            return result;
        });
    }
    // Chain api
    Stake(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("chain/stake", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    Transaction(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("chain/transaction", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    AvgBlockTime(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                hours: req.hours,
            };
            const request = this.apiManager.path("chain/blocktime", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    Inflation() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("chain/inflation");
            const response = yield request.get();
            return response.data;
        });
    }
    // User api
    ActiveAccounts(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/active", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    UserProfile(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/profile", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    UserGrowth(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/growth", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    UserVolume(req, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/volume", req, query);
            const response = yield request.get();
            const rawEntries = response.data.result.entries;
            const meta = response.data.result.meta;
            const parsedEntries = rawEntries.map(entry => ({
                lastHeight: entry.lastHeight,
                time: dayjs_1.default(entry.time),
                volumeValue: new bignumber_js_1.default(entry.volumeValue),
            }));
            const parsedMeta = {
                from: dayjs_1.default(meta.from),
                until: dayjs_1.default(meta.until),
                interval: meta.interval,
            };
            return { result: { entries: parsedEntries, meta: parsedMeta } };
        });
    }
    TotalUsers(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/total", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    UserPnl(req, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/pnl", req, query);
            const response = yield request.get();
            return response.data;
        });
    }
    UserBalanceGraph(req, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/balance/graph", req, query);
            const response = yield request.get();
            return response.data;
        });
    }
    UserPnlGraph(req, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("user/pnl/graph", req, query);
            const response = yield request.get();
            return response.data;
        });
    }
    // Pool api
    Pools(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("pool/list", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    PoolHistory(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("pool/history", {}, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : "DESC",
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
                poolId: query.poolId,
            });
            const response = yield request.get();
            return response.data;
        });
    }
    PerpPoolHistory(query) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("pool/perp/history", {}, {
                limit: (_a = query.limit) !== null && _a !== void 0 ? _a : 10,
                offset: (_b = query.offset) !== null && _b !== void 0 ? _b : 0,
                address: query.address,
            });
            const response = yield request.get();
            return response.data;
        });
    }
    PerpPoolApy(query) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = { id: query.id };
            const request = this.apiManager.path("pool/perp/apy", routeParams, {
                limit: (_a = query.limit) !== null && _a !== void 0 ? _a : 10,
                offset: (_b = query.offset) !== null && _b !== void 0 ? _b : 0,
            });
            const response = yield request.get();
            return response.data;
        });
    }
    PoolVolume(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = { poolId: req.poolId };
            const queryParams = {
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path("pool/volume", routeParams, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    PoolsVolume(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                market: req.market,
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path("pools/volume", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    UserRewardsClaimHistory(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = { address: req.address };
            const request = this.apiManager.path("user/pool/rewards", routeParams, req);
            const response = yield request.get();
            return response.data;
        });
    }
    UserWalletConnected(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('user/connected/wallet');
            const response = yield request.post({ body });
            return response.data;
        });
    }
    CompetitionList(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("competition/list", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    /**
     * endpoint for legacy Demex Trading volume Competition (circa. 2021-2022). Keeping this here as endpoint has not been removed.
     */
    VolumeCompetitionLeaderboard(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.assign(Object.assign(Object.assign({ competitionId: req.competitionId }, (req.from && { from: req.from })), (req.until && { until: req.until })), (req.market && { market: req.market }));
            const request = this.apiManager.path("competition/leaderboard", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    /**
     * endpoint for Perps Trading Competition on Demex (14 Nov 2023 - 28 Nov 2023).
    */
    PerpsTradingCompetitionVolume(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.assign({ competitionId: req.competitionId }, (req.address && { address: req.address }));
            const request = this.apiManager.path("competition/leaderboardvolume", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    PNLCompetitionLeaderboard(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.assign({ competitionId: req.competitionId }, (req.market && { market: req.market }));
            const request = this.apiManager.path("competition/leaderboardpnl", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    LotteryCompetitionLeaderboard(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.assign({ competitionId: req.competitionId }, (req.market && { market: req.market }));
            const request = this.apiManager.path("competition/leaderboardlottery", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    LeagueCompetitionLeaderboard(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                competitionId: req.competitionId,
            };
            const request = this.apiManager.path("competition/leaderboardleague", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    PoolsLiquidity(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                poolId: req.poolId,
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path("pools/liquidity", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    MarketsVolume(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                market: req.market,
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path("market/volume", {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    CarbonCreditsRewards(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = { epoch: req.epoch, unixStart: req.unixStart };
            const request = this.apiManager.path('reward/epoch', routeParams, {});
            const response = yield request.get();
            return response.data;
        });
    }
    PnlLeaderboard(req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = { unixStart: req.unixStart, unixEnd: req.unixEnd };
            const queryParams = {
                limit: (_a = req.limit) !== null && _a !== void 0 ? _a : 100,
                market: (_b = req.market) !== null && _b !== void 0 ? _b : '',
                offset: 0,
                sort: 'DESC',
            };
            const request = this.apiManager.path('reward/leaderboard', routeParams, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    // Node api
    Nodes(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("node/list", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    // Balance api
    BalanceTotal(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("balance/total", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceList(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("balance/list", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceChange(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("balance/change", req);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceHistory(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = {
                address: req.address,
                denom: req.denom,
            };
            const queryParams = {
                interval: req.interval,
                limit: req.limit,
            };
            const request = this.apiManager.path("balance/history", routeParams, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceSupply() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("balance/supply");
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceDistribution(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("balance/distribution", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    // Positions api
    LiquidationEngine(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("position/liquidation/engine", {}, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : "DESC",
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
            });
            const response = yield request.get();
            return response.data;
        });
    }
    LiquidationAndADL(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("position/liquidation", {}, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : "DESC",
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
            });
            const response = yield request.get();
            return response.data;
        });
    }
    PositionsView(req, query) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("position/view", req, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : "DESC",
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
                market: (_d = query.market) !== null && _d !== void 0 ? _d : "",
            });
            const response = yield request.get();
            return response.data;
        });
    }
    Leaderboard(req, query) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("position/leaderboard", req, {
                market: (_a = query.market) !== null && _a !== void 0 ? _a : "",
                sort: (_b = query.sort) !== null && _b !== void 0 ? _b : "DESC",
                limit: (_c = query.limit) !== null && _c !== void 0 ? _c : 100,
                offset: (_d = query.offset) !== null && _d !== void 0 ? _d : 0,
                address: (_e = query.address) !== null && _e !== void 0 ? _e : "",
            });
            const response = yield request.get();
            return response.data;
        });
    }
    PositionStats(req, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("position/stats", req, query);
            const response = yield request.get();
            return response.data;
        });
    }
    //Coin Gecko Tokens
    DenomToGeckoIdMap() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("info/denom_gecko_map");
            const response = yield request.get();
            return response.data;
        });
    }
    FundingHistory(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("market/funding/history/all", {}, {
                market: (_a = query.market) !== null && _a !== void 0 ? _a : "",
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
            });
            const response = yield request.get();
            return response.data;
        });
    }
    HistoricalFundingHistory(query) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("market/funding/history", {}, {
                market: (_b = (_a = query.market) === null || _a === void 0 ? void 0 : _a.replace('%2F', '/')) !== null && _b !== void 0 ? _b : "",
            });
            const response = yield request.get();
            return response.data;
        });
    }
    ProposalVotes(req, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("proposal/votes", req, query);
            const response = yield request.get();
            return response.data;
        });
    }
    Delegations(req, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("delegations/delegator", req, query);
            const response = yield request.get();
            return response.data;
        });
    }
    OraclePrices(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("info/oracles_price", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    AlliancesStake(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("alliances/stake", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    AlliancesRewards(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path("alliances/rewards", {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
}
exports.default = InsightsQueryClient;
